import React from 'react';
import BadgeCard from './BadgeCard';

/**
 * One category section: title, unlocked/total counter, "Vedi tutto" link,
 * and a horizontally scrollable carousel of badges.
 */
function BadgeCategoryRow({ label, badges, stats, earnedMap, selectedKey, onBadgeClick, onSeeAll }) {
  if (!badges.length) return null;
  const unlocked = badges.filter((b) => earnedMap.has(b.key)).length;

  return (
    <div className="space-y-2.5">
      <div className="flex items-center justify-between px-1">
        <div className="flex items-baseline gap-2">
          <h3 className="text-sm font-bold text-gray-800">{label}</h3>
          <span className="text-xs font-medium text-gray-400">
            {unlocked}/{badges.length}
          </span>
        </div>
        <button
          type="button"
          onClick={onSeeAll}
          className="text-xs font-semibold text-primary-600 active:opacity-70"
        >
          Vedi tutto
        </button>
      </div>

      {/* Carosello orizzontale: scrollbar nascosta, snap, bleed ai bordi.
          pt-2/pb-2 danno spazio agli overlay -top-1/-bottom-1 (★/🔒) così
          nessuna card viene tagliata verticalmente; px-4 -mx-4 dà margine
          corretto a sinistra e destra. */}
      <div className="flex gap-3 overflow-x-auto pt-2 pb-2 px-4 -mx-4 snap-x [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
        {badges.map((b) => (
          <BadgeCard
            key={b.key}
            badge={b}
            stats={stats}
            earned={earnedMap.has(b.key)}
            earnedAt={earnedMap.get(b.key)}
            selected={selectedKey === b.key}
            onClick={() => onBadgeClick(b)}
          />
        ))}
      </div>
    </div>
  );
}

export default BadgeCategoryRow;
